import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Building2 } from "lucide-react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const [contactInfo, setContactInfo] = useState({
    name: "ctb28.fr",
    title: "La tranquillité pour vos travaux",
  phone: "07 65 63 25 84",
    email: "contact@ctb28.fr",
    address: "Eure-et-Loir (28) Essonne (91), Loiret (45)",
    hours: "Lun-Ven : 8h-18h, Sam : 9h-12h"
  });

  useEffect(() => {
    const loadContactInfo = async () => {
      try {
        const response = await axios.get(`${API}/public/contact-info`);
        setContactInfo(prev => ({
          ...prev,
          ...response.data
        }));
      } catch (error) {
        console.error("Erreur lors du chargement des informations de contact:", error);
      }
    };
    loadContactInfo();
  }, []);

  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2 space-y-4">
            <div className="flex items-center space-x-5">
              <img
                src="/ctb28.png"
                alt="CTB28"
                className="h-16 w-auto select-none"
                draggable={false}
              />
              <p
                className="text-sm md:text-base font-light tracking-wide italic"
                style={{ color: '#0d8c6a', fontFamily: 'cursive' }}
              >
                La tranquillité pour vos travaux
              </p>
            </div>
            <p className="text-gray-300 leading-relaxed max-w-md">
              Expert en bâtiment depuis plus de 40 ans, j'accompagne particuliers
              et professionnels dans la réalisation de leurs projets de construction,
              rénovation et aménagement en Eure-et-Loir (28), Essonne (91) et Loiret (45).
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-3">
                <Phone className="w-4 h-4 text-blue-400" />
                <span className="text-gray-300">{contactInfo.phone}</span>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-4 h-4 text-blue-400" />
                <span className="text-gray-300">{contactInfo.email}</span>
              </div>
              <div className="flex items-center space-x-3">
                <MapPin className="w-4 h-4 text-blue-400" />
                <span className="text-gray-300">{contactInfo.address}</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              {[
                { name: "Accueil", id: "accueil" },
                { name: "À propos", id: "a-propos" },
                { name: "Services", id: "services" },
                { name: "Réalisations", id: "realisations" },
                { name: "Contact", id: "contact" }
              ].map((link) => (
                <li key={link.id}>
                  <button
                    onClick={() => scrollToSection(link.id)}
                    className="text-gray-300 hover:text-blue-400 transition-colors duration-200"
                  >
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Nos Services</h4>
            <ul className="space-y-2">
              <li className="text-gray-300">Étude de faisabilité</li>
              <li className="text-gray-300">Conseil en matériaux</li>
              <li className="text-gray-300">Suivi de chantier</li>
              <li className="text-gray-300">Conseil travaux</li>
              <li className="text-gray-300">Lecture de devis</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © {currentYear} {contactInfo.title}. Tous droits réservés.
            </div>
            <div className="flex space-x-6 text-sm">
              <a href="/mentions-legales" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">Mentions légales</a>
              <a href="/politique-confidentialite" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">Politique de confidentialité</a>
              <a href="/cgv" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-blue-400 transition-colors duration-200">CGV</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;